import { render, staticRenderFns } from "./Sheet-metal.vue?vue&type=template&id=85d3c950&scoped=true"
import script from "./Sheet-metal.vue?vue&type=script&lang=js"
export * from "./Sheet-metal.vue?vue&type=script&lang=js"
import style0 from "./Sheet-metal.vue?vue&type=style&index=0&id=85d3c950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d3c950",
  null
  
)

export default component.exports